<template>
  <div class="wrapper-items wh100p">
    <section class="section-navs df">
      <div class="nav _themecolor active f-m">
        {{$t('shop.shopStatus')}}：
        <span :class="'nav-'+shop_x.businessStatus">{{shop_x.businessStatus?$t('index.inBusiness'):$t('index.outBusiness')}}</span>
      </div>
    </section>
    <section class="section-con df">
      <div class="df">
        <div class="themebtn btn" @click="shopStatusChange">{{shop_x.businessStatus?$t('shop.outBusiness'):$t('shop.inBusiness')}}</div>
        <div class="whitebtn btn ml20" @click="$refs.Dialog_report.open()">{{$t('shop.printReport')}}</div>
      </div>
      <div class="reports df f1">
        <!-- <ReportTotal ref="ReportTotal" />
        <ReportCashDrawer ref="ReportCashDrawer" v-if="user_x.privilegeList&&user_x.privilegeList.includes('sjzhgl_bdxjgl')" />
        <ReportDishes ref="ReportDishes" /> -->
        <el-carousel ref="slideCarousel" class="w100p" height="100%" :autoplay="false" :loop="false" arrow="always" indicator-position="none">
          <el-carousel-item>
            <div class="df-l-c-fs wh100p">
              <ReportTotal ref="ReportTotal" />
            </div>
          </el-carousel-item>
          <el-carousel-item v-if="user_x.privilegeList&&user_x.privilegeList.includes('sjzhgl_bdxjgl')">
            <div class="df-l-c-fs wh100p">
              <ReportCashDrawer ref="ReportCashDrawer" />
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="df-l-c-fs wh100p">
              <ReportDishes ref="ReportDishes" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </section>

    <DialogSellout ref="DialogSellout" />

    <DialogKey ref="DialogKey" />

    <Dialog
      ref="Dialog_partpay"
      contentWidth="500"
      :dialogTitle="$t('common.tips')"
      :closeable="true">
      <!-- contentWidth="700" -->
      <!-- :closeable="false" -->

      <div class="mydialog3 df-c-ct" slot="content">
        <div class="f-l text">{{$t('shop.isContinueClosing')}}</div>
      </div>

      <template slot="footer">
        <div class="whitebtn" @click="cancelClosing">{{$t('common.cancel')}}</div>
        <div class="themebtn" @click="continueClosing">{{$t('common.comfirm')}}</div>
      </template>

    </Dialog>

    <Dialog
      ref="Dialog_partdone"
      contentWidth="500"
      :dialogTitle="$t('common.tips')"
      :closeable="true">
      <!-- contentWidth="700" -->
      <!-- :closeable="false" -->

      <div class="mydialog3 df-c-ct" slot="content">
        <div class="f-l text">{{$t('shop.isContinueClosing2')}}</div>
      </div>

      <template slot="footer">
        <div class="whitebtn" @click="cancelClosing2">{{$t('common.cancel')}}</div>
        <div class="themebtn" @click="continueClosing2">{{$t('common.comfirm')}}</div>
      </template>

    </Dialog>

    <Dialog
      ref="Dialog_askreport"
      :contentWidth="lang==='en'?'600':'500'"
      :dialogTitle="$t('shop.closingReport')"
      :closeable="true">
      <!-- contentWidth="700" -->
      <!-- :closeable="false" -->

      <div class="df-c-ct" style="padding: 80px 0;" slot="content">
        <div class="f-l">{{$t('shop.isPrintClosingReport')}}</div>
      </div>

      <template slot="footer">
        <div class="whitebtn" @click="$refs.Dialog_askreport.close()">{{$t('common.no')}}</div>
        <div class="themebtn" @click="$refs.Dialog_askreport.close(),$refs.Dialog_report.open()">{{$t('common.yes')}}</div>
      </template>

    </Dialog>

    <Dialog
      ref="Dialog_report"
      contentWidth="1000"
      :dialogTitle="$t('shop.closingReport')"
      :closeable="true">
      <!-- :closeable="false" -->

      <div class="mydialog2 df-c-ct" slot="content">
        <div class="half df-l-c-ct">
          <div class="box">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" class="item bold" @change="handleCheckAllChange">{{$t('common.selectAll')}}</el-checkbox>
            <el-checkbox-group v-model="reportsChecked" v-for="(x,i) in reportsOptions" :key="i" @change="handleCheckedCitiesChange">
              <el-checkbox :label="x2.key" v-for="(x2,i2) in x" :key="i2" class="item">{{x2.i18nKey?$t('shop.'+x2.i18nKey):x2['name'+_lang]}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="whitebtn-l" :class="{'_be':reportsChecked&&reportsChecked.length===0}" @click="printDetailReport">{{$t('shop.printDetail')}}</div>
        </div>
        <div class="half df-l-c-ct">
          <div class="themebtn-l" @click="printCompleteReport">{{$t('shop.printAll')}}</div>
          <div class="themebtn-l mt20" @click="printDishReport">{{$t('shop.printDish')}}</div>
          <div class="themebtn-l mt20" @click="printCashReport">{{$t('shop.printCash')}}</div>
        </div>
      </div>

      <template slot="footer">
      </template>

    </Dialog>

    <DialogTipError ref="DialogTipError" @submit="submitDialogKey" />

  </div>
</template>

<script>
import DialogSellout from '@/components/DialogSellout'
import ReportTotal from './components/ReportTotal'
import ReportCashDrawer from './components/ReportCashDrawer'
import ReportDishes from './components/ReportDishes'
import DialogTipError from './components/DialogTipError'
export default {
  name: 'shop',
  components: { DialogSellout, ReportTotal, ReportCashDrawer, ReportDishes, DialogTipError },
  data() {
    return {
      isIndeterminate: false,
      checkAll: false,
      reportsOptions: [
        [
          // {key:'cash',i18nKey:'cash'}, // 现金
          // {key:'weixin',i18nKey:'wechat'}, // 微信
          // {key:'alipay',i18nKey:'alipay'}, // 支付宝
          // {key:'creditCard',i18nKey:'card'}, // 信用卡
          // {key:'badatong',i18nKey:'octopus'}, // 八达通
          // {key:'stripe',i18nKey:'stripe'}, // Stripe
        ], [
          {key:'tangshi',i18nKey:'tangshi'}, // 堂食
          {key:'takeout',i18nKey:'takeout'}, // 自营外卖
          {key:'takeoutPlat',i18nKey:'platform'}, // 外卖平台
        // ], [
        //   {key:'catalog',i18nKey:'type'}, // 品类
        //   {key:'total',i18nKey:'all'}, // 总额
        ],
      ],
      reportsKeys: [
        // 'stripe',
        'tangshi',
        'takeout',
        'takeoutPlat',
        // 'catalog',
        // 'total',
      ],
      reportsChecked: [],

    }
  },
  methods: {
    // 1 如果是开店则查询是否有售罄，如果有售罄则询问是否恢复，否则结束
    // 2 如果是闭店则查询当前是否有未付款订单，询问是否继续
    // 2-1 如果继续，要求输入二级密码
    // 2-2 判断正确后，查询是否已经打印报告，没有则弹框询问是否打印
    async shopStatusChange() {
      if (this.shop_x.businessStatus) {
        if (await this.queryNotPayOrder()) {
          if (await this.queryNotPassBook()) {
            this.handlePasswordProjection() // 处理密码保护
          }
        }
      } else {
        this.handlePasswordProjection() // 处理密码保护
      }
    },
    async queryNotPayOrder() {
      return this.$api.order_not_pay_search({ id: this.currentShopId }).then(res => {
        if (res.status == 0) {
          let _R = res.data
          console.log(`%c是否有未付款订单:`, 'color: #f00;', _R)
          if (_R) {
            this.scan_canLeave_x_save(false)
            this.$refs.Dialog_partpay && this.$refs.Dialog_partpay.open()
            return false
          } else {
            return true
          }
        } else { this._status(res) }
      })
    },
    async queryNotPassBook() {
      return this.$api.book_not_done_search({ id: this.currentShopId }).then(res => {
        if (res.status == 0) {
          let _R = res.data
          console.log(`%c是否有未处理预定:`, 'color: #f00;', _R)
          if (_R) {
            this.scan_canLeave_x_save(false)
            this.$refs.Dialog_partdone && this.$refs.Dialog_partdone.open()
            return false
          } else {
            return true
          }
        } else { this._status(res) }
      })
    },
    // 处理密码保护，如果后台权限设置了当前账号需要输入二级密码，则弹框输入
    handlePasswordProjection() {
      // if (this.user_x.privilegeList.includes('sjzhgl_bddpztmmbh')) {
        this.scan_canLeave_x_save(false)
        this.$refs.DialogKey && this.$refs.DialogKey.open({
          onConfirm: (val) => this.submitDialogKey(val)
        })
      // } else {
      //   this.submitDialogKey(val)
      // }
    },
    // 有未支付订单 点击取消切换店铺状态
    cancelClosing() {
      this.scan_canLeave_x_save(true)
      this.$refs.Dialog_partpay && this.$refs.Dialog_partpay.close()
    },
    // 有未支付订单 点击继续切换店铺状态
    continueClosing() {
      this.$refs.Dialog_partpay && this.$refs.Dialog_partpay.close()
      let timer = setTimeout(async () => {
        if (await this.queryNotPassBook()) {
          this.handlePasswordProjection() // 处理密码保护
        }
        clearTimeout(timer)
      }, 300)
    },
    // 有未处理预定 点击取消切换店铺状态
    cancelClosing2() {
      this.scan_canLeave_x_save(true)
      this.$refs.Dialog_partdone && this.$refs.Dialog_partdone.close()
    },
    // 有未处理预定 点击继续切换店铺状态
    continueClosing2() {
      this.$refs.Dialog_partdone && this.$refs.Dialog_partdone.close()
      let timer = setTimeout(() => {
        this.handlePasswordProjection() // 处理密码保护
        clearTimeout(timer)
      }, 300)
    },
    // 关闭对话框 提交密匙
    async submitDialogKey(val) {
      this.el_loading_x_save(true)
      const CURRENT_STATUS = this.shop_x.businessStatus
      CURRENT_STATUS && this.$refs.DialogTipError && this.$refs.DialogTipError.open(null)
      
      const rD = {
        shopId: this.currentShopId,
        businessStatus: !CURRENT_STATUS,
        lang: this.lang,
        // secondaryPassword: val,
      }
      if (val) {
        rD.secondaryPassword = val
      }
      this.$api.shop_status_change(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          if (_R === '') {
            this.$refs.DialogTipError && this.$refs.DialogTipError.close()

            // 重新缓存当前店铺状态
            this.shop_x.businessStatus = !CURRENT_STATUS
            this.shopConfig_m.controlDay = 0
            this.shop_x_save(this.shop_x)

            // 开店则查询是否有售罄，闭店则查询是否已经打印报告
            if (CURRENT_STATUS) {
              this.$refs.Dialog_askreport && this.$refs.Dialog_askreport.open()
            } else {
              this.$refs.DialogSellout && this.$refs.DialogSellout.checkSellOut()
            }
          } else if (_R && _R.id) {
            // console.log(`%c_D:`, 'color: #f00;', _R)
            
            this.$refs.DialogTipError && this.$refs.DialogTipError.open(_R)
          }
          this.el_loading_x_save(false)
        } else { this._status(res) }
      })
    },


    // 全选
    handleCheckAllChange(val) {
      this.reportsChecked = val ? this.reportsKeys : []
      this.isIndeterminate = false
    },
    // 勾选
    handleCheckedCitiesChange(val) {
      // console.log(`%cval:`, 'color: #00f;', val)
      let checkedCount = val.length
      this.checkAll = checkedCount === this.reportsKeys.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.reportsKeys.length
    },
    // 点击打印详情报告
    printDetailReport() {
      if (this.reportsChecked.length) {
        if (this.printerId_x) {
          let rD = { id: this.currentShopId }
          // this.reportsChecked.forEach(x => rD[x] = true)
          rD.tangshi = this.reportsChecked.includes('tangshi')
          rD.takeout = this.reportsChecked.includes('takeout')
          rD.takeoutPlat = this.reportsChecked.includes('takeoutPlat')
          rD.payTypeList = JSON.parse(JSON.stringify(this.reportsChecked))
          rD.payTypeList = rD.payTypeList.filter(x1 => typeof x1 === 'number')
          // console.log(rD)
          this.$api.print_report_detail(rD, this.printerId_x).then(res => {
            if (res.status == 0) {
              this.$refs.Dialog_report && this.$refs.Dialog_report.close()
            } else { this._status(res) }
          })
        } else { this.$message.warning(this.$t('print.printerError')) }
      }
    },
    // 点击打印总报告
    printCompleteReport() {
      if (this.printerId_x) {
        this.$api.print_report_all({ id: this.currentShopId }, this.printerId_x).then(res => {
          if (res.status == 0) {
            this.$refs.Dialog_report && this.$refs.Dialog_report.close()
          } else { this._status(res) }
        })
      } else { this.$message.warning(this.$t('print.printerError')) }
    },
    // 点击打印菜品报告
    printDishReport() {
      if (this.printerId_x) {
        this.$api.print_report_dish({ id: this.currentShopId }, this.printerId_x).then(res => {
          if (res.status == 0) {
            this.$refs.Dialog_report && this.$refs.Dialog_report.close()
          } else { this._status(res) }
        })
      } else { this.$message.warning(this.$t('print.printerError')) }
    },
    // 点击打印现金报告
    printCashReport() {
      if (this.printerId_x) {
        this.$api.print_report_cash({ id: this.currentShopId }, this.printerId_x).then(res => {
          if (res.status == 0) {
            this.$refs.Dialog_report && this.$refs.Dialog_report.close()
          } else { this._status(res) }
        })
      } else { this.$message.warning(this.$t('print.printerError')) }
    },

    // 获取数据
    getDataHandler() {
      this.getShopCompanyData()
      this.$refs.ReportTotal && this.$refs.ReportTotal.getReport()
      this.$refs.ReportCashDrawer && this.$refs.ReportCashDrawer.getReport()
      this.$refs.ReportDishes && this.$refs.ReportDishes.getReport()
    },
    async initPayType() {
      const _R = await this.getData('paytype', {
        shopId: this.currentShopId,
        queryTransientData: true
        // enable: true
      })
      // console.log(`%c支付方式:`, 'color: #f00;', _R)
      this.reportsOptions[0] = _R.map(x1 => ({
        name_zh: x1.name_zh,
        name_en: x1.name_en,
        key: x1.type
      }))
      // this.reportsOptions[0].push({
      //   name_zh: 'Stripe',
      //   name_en: 'Stripe',
      //   key: 11
      // })
      this.reportsKeys = [
        ...this.reportsKeys,
        ..._R.map(x1 => x1.type),
        // 11
      ]
      this.reportsOptions = JSON.parse(JSON.stringify(this.reportsOptions))
      // console.log(`%c11111111111:`, 'color: #00f;', this.reportsOptions, this.reportsOptions[0].length, this.reportsKeys)
    },

    // #region 轮播
    // 滑动切换
    slideBanner() {
      //选中的轮播图
      var box = document.querySelector('.el-carousel__container');
      var startPoint = 0;
      var stopPoint = 0;
      //重置坐标
      var resetPoint = function () {
        startPoint = 0;
        stopPoint = 0;
      }
      //手指按下
      box.addEventListener("touchstart", function (e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener("touchend", function (e) {
        // console.log("1：" + startPoint);
        // console.log("2：" + stopPoint);
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        const THRESHOLD = 120
        if (startPoint - stopPoint > THRESHOLD) {
          resetPoint();
          that.$refs.slideCarousel.next();
          return;
        }
        if (startPoint - stopPoint < -THRESHOLD) {
          resetPoint();
          that.$refs.slideCarousel.prev();
          return;
        }
      });
    },
    // #endregion
  },
  created() {
    this.initPayType()
  },
  mounted() {
    //调用方法
    this.slideBanner()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getDataHandler()
    })
  },
}
</script>

<style lang='scss' scoped>
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;margin-bottom: 20px;
  overflow: scroll hidden;
  .nav{padding: 0 10px;width: auto;white-space: nowrap;}
  .nav.active{font-weight: bold;}
  .nav-true{color: #007B84;}
  .nav-false{color: #999;}
}
.section-con{
  height: calc(100% - 100px);padding-left: 20px;
  .btn{width: 200px;height: 80px;line-height: 80px;}
  .reports{overflow: scroll;margin-left: 20px;}
}
.mydialog2{
  padding: 40px 0;
  .half{width: 50%;}
  .box{border-right: 1px solid #374978;padding: 0 40px 40px;}
  .item{width: auto;height: 50px;line-height: 50px;margin-right: 40px;}
  /deep/.el-checkbox__label{font-size: 16px;}
  .bold /deep/.el-checkbox__label{font-weight: bold;}
}
.mydialog3{
  padding: 80px;
  .text{word-break: keep-all;line-height: 2;text-align: center;}
}
._be{background-color: #eee;}
</style>